// extracted by mini-css-extract-plugin
export default {"heading":"yy-z","corrected":"zy-z","redirectVerbiageContainer":"Ay-z","redirectVerbiageText":"By-z"};